export default __webpack_public_path__ + "935bf9357302090f1d300ffb26ebfaf9.png";